import { toast } from 'react-toastify';
import { navigate } from '../../utils/navigation';

export const authMiddleware = (store) => (next) => (action) => {
  if (action?.type?.endsWith('/rejected')) {
    const payload = action.payload;
    let errorData = null;

    try {
      errorData = typeof payload === 'string' ? JSON.parse(payload) : payload;
    } catch (e) {
    }

    if (errorData && (errorData.error === 'TOKEN_EXPIRED' || errorData.message === 'Unauthenticated.')) {
      localStorage.removeItem("OrviSlideToken");
      localStorage.removeItem("OrviSlideAuth");

      toast.error('Session expired. Please login again.');

      if (navigate && window.location.pathname !== '/login') {
        navigate('/login');
      } else if (!navigate && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }

  return next(action);
};
